import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { awsRum } from "../util/awsRum";

/**
 * Hook that handles analytics tracking and monitoring:
 * - Records page views in AWS RUM
 * - Handles tracking availability gracefully
 */
export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (awsRum) {
      awsRum.recordPageView(location.pathname);
    }
  }, [location]);
};
